import { isVerifyDocumentErrorResponse } from '../validators/verifyDocumentValidators';
import { createGenericTransformVerifyErrorResponse } from '../validation.helpers';

export const transformVerifyDocumentErrorResponse =
  createGenericTransformVerifyErrorResponse(isVerifyDocumentErrorResponse);
